// src/components/GTMProvider.tsx

import { useEffect } from 'react';
import { gtmService } from '@/services/retargeting/gtm.service';

/**
 * GTMProvider Component (Google Ads Tracking)
 * Initializes Google Ads conversion tracking on app mount
 * Should be placed near the root of your app
 */
export const GTMProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    useEffect(() => {
        console.log('GTMProvider mounted, initializing Google Ads tracking');

        // Initialize Google Ads tracking when component mounts
        gtmService.initialize();

        // Track page view after script loads
        // Wait for script to load or use stub
        const trackPageView = () => {
            const maxAttempts = 10;
            let attempts = 0;

            const tryTrack = () => {
                attempts++;

                if (gtmService.isReady()) {
                    console.log('Google Ads ready, tracking page view');
                    gtmService.trackPageView();
                } else if (attempts < maxAttempts) {
                    console.log(`Google Ads not ready yet, attempt ${attempts}/${maxAttempts}`);
                    setTimeout(tryTrack, 500);
                } else {
                    console.warn('Google Ads tracking timed out after', attempts, 'attempts');
                    // Still try to track - it will queue if needed
                    gtmService.trackPageView();
                }
            };

            // Start tracking attempts after small delay
            setTimeout(tryTrack, 100);
        };

        trackPageView();

        return () => {
            console.log('GTMProvider unmounting');
        };
    }, []);

    return <>{children}</>;
};